import {
  IMeetingAgendaModel,
  IMeetingAgendaSubmitModel,
} from '../models/BoardMeeting'

export const updateOrderOnAgendaItems = (
  items: IMeetingAgendaModel[],
  orderItems: IMeetingAgendaSubmitModel[]
): IMeetingAgendaModel[] => {
  const list = new Array(...items).map((item) => {
    const updatedOrder = orderItems.find(({ caseId }) => caseId === item.caseId)

    if (!updatedOrder) return item

    return {
      ...item,
      order: updatedOrder.order,
    }
  })

  const sorted = list.sort((a, b) => {
    if (a.order > b.order) return 1
    if (a.order < b.order) return -1
    return 0
  })

  return sorted
}

export const createNewCaseOrder = (
  items: IMeetingAgendaModel[]
): IMeetingAgendaSubmitModel[] =>
  items.map((item: IMeetingAgendaModel, index: number) => ({
    caseId: item.caseId,
    order: index + 1,
  }))

export const handleDropList = (
  items: IMeetingAgendaModel[],
  start: number,
  end: number
) => {
  let result = Array.from(items)
  const [removed] = result.splice(start, 1)
  result.splice(end, 0, removed)

  return result
}
